import client from '../utils/ajax/client';
import {
    LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGOUT_USER,
    USER_PROFILE_GET_REQUEST, USER_PROFILE_GET_SUCCESS, USER_PROFILE_GET_FAILURE,
    USER_PROFILE_UPDATE_REQUEST, USER_PROFILE_UPDATE_SUCCESS, USER_PROFILE_UPDATE_FAILURE,
    USER_CHANGE_PASSWORD_REQUEST, USER_CHANGE_PASSWORD_SUCCESS, USER_CHANGE_PASSWORD_FAILURE,
    USER_RESET_PASSWORD_REQUEST, USER_RESET_PASSWORD_SUCCESS, USER_RESET_PASSWORD_FAILURE,
    FORCE_AUTH_RECHECK
} from '../constants/actionconstants';
import { ROUTE_SIGNIN } from '../constants/routeconstants';
import { push } from 'react-router-redux';
import * as GlobalErrorActions from '../actions/globalerror';

function loginUserSuccess(user) {
    return {
        type: LOGIN_USER_SUCCESS,
        payload: user
    }
}

export function loginUserSuccessFromServer(user) { // exported, since this action is also called from backend.
    user = {
        ...user,
        photo: null, // <- photo doesn't work from server yet (is a Buffer object - is in session but not serializable)
        photoMimeType: null
    };
    return loginUserSuccess(user);
}

function loginUserFailure(error) {
    return {
        type: LOGIN_USER_FAILURE,
        payload: {
            status: error.response.status,
            statusText: error.response.statusText
        }
    }
}

function loginUserRequest() {
    return {
        type: LOGIN_USER_REQUEST
    }
}

function logout() {
    return {
        type: LOGOUT_USER
    }
}

export function setForceAuthRecheck(mustRecheck) { // This is sat by the timer in app.js, and read by requireAuth.js, to make requireAuth.js periodically recheck whether the user is still logged in (or has been logged out by the backend)
    return {
        type: FORCE_AUTH_RECHECK,
        payload: {
            mustRecheck: mustRecheck
        }
    }
}

export function loginCheckSession(onNotAuthenticated = null) {
    return (dispatch, state) => {
        dispatch(loginUserRequest());
        client({
            method : 'GET',
            path : '/me'
        }).then(response => {
            if (clientConfig.config.debug_logging) console.log("User", response.entity.id, response.entity.email, response.entity.roleId, response.entity.firstName, response.entity.lastName);
            dispatch(loginUserSuccess(response.entity));
        }).catch(response => {
            // TODO: TEMP FIX: According to the rest.js-docs this should be a response object, but it sometimes is missing response.status... and reading response.status.code makes the _server_ crash. (To make it happen: after having logged in, reload the page you are on)
            // TODO: (Seems to happen only serverside. Why does the server call this code???)
            if (typeof(response.status) === "undefined") response.status = {code: -1};

            if (response.status.code === 404 || response.status.code === 401) {
                dispatch(loginUserFailure({
                    response: {
                        status: 404,
                        statusText: 'Invalid Session'
                    }
                }));

                if (onNotAuthenticated !== null) onNotAuthenticated();

            } else {
                console.log("********ERROR!", response);

                dispatch(loginUserFailure({
                    response: {
                        status: response.status.code,
                        statusText: 'Server error'
                    }
                }));
                dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Server error (" + response.status.code + ")", response));

                // To avoid infinite loops from requireAuth.js on server error (for example if server is down and we are at a page protected by requireAuth.js) this redirects to signin.
                // (Try it to see what i mean: uncomment the redirect, shut down the backend and wait for the timer in app.js to call loginCheckSession)
                // (Seen from the frontend's point of view, the user has been logged out - loginUserFailure takes care of that - so it makes sense going to the login page)
                dispatch(push(ROUTE_SIGNIN));
            }
        });
    }
}

export function logoutAndRedirect() {
    return (dispatch, state) => {
        client({
            // method : 'DELETE',
            // path : '/web/session'
            method : 'POST',
            path : '/logout'
        }).then(response => {
            dispatch(push(ROUTE_SIGNIN)); // <- must be done BEFORE the logout() call
            dispatch(logout()); // <- this MUST be after redirecting to signin-page (push(ROUTE_SIGNIN)), since if this is called AND the page we're at is wrapped by requireAuth (See approute.js), requireAuth's props will change, and it will
                                //    send a /web/session request, which will WRONGLY append the "?next=xxx" query-parameter to the URL. That will make the next user logging in go to that page (which he might not have access to and will result in errors!).
                                //    (Yes, dispatch IS synchronous)
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while logging out", response));
        });
    }
}

export function loginUser(username, password, redirect = "/", onInvalidCredentials = null) {
    return function(dispatch) {
        dispatch(loginUserRequest());

        client({
            method: "POST",
            path: "/login",
            entity: {
                username : username,
                password : password
            },
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            if (clientConfig.config.debug_logging) console.log("User", response.entity.id, response.entity.email, response.entity.roleId, response.entity.firstName, response.entity.lastName);
            dispatch(loginUserSuccess(response.entity));
            dispatch(push(redirect));
            if (clientConfig.config.debug_logging) console.log('********LOGGED IN********');
        }).catch(response => {
            if (clientConfig.config.debug_logging) console.log('********LOGIN FAILED ('+response.status.code+')********');

            if (response.status.code === 401) {

                dispatch(loginUserFailure({
                    response: {
                        status: response.status.code,
                        statusText: 'Invalid Credentials'
                    }
                }));

                if (onInvalidCredentials !== null) onInvalidCredentials();
                else dispatch(GlobalErrorActions.addGlobalError("Invalid credentials - please try again", ""));

            } else {

                dispatch(loginUserFailure({
                    response : {
                        status: response.status.code,
                        statusText: 'Server error'
                    }
                }));
                console.log("server error: " + response.status.code);

                dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while logging in - please try again later", response));
            }
        });
    }
}


export function getProfile(onSuccess = null, onError = null) { // is in this file, rather than actions/user.js, since it gets the currently logged in user, and thus uses the auth part of the store.
    return function (dispatch) {
        dispatch(getProfileRequest());
        client({
            method: 'GET',
            path: '/api/user/current',
        }).then(response => {
            dispatch(getProfileSuccess(response));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while retrieving your profile", response));
            dispatch(getProfileFailure(response));
            if (onError !== null) onError();
        });
    };
}

function getProfileRequest() {
    return {
        type: USER_PROFILE_GET_REQUEST
    };
}

function getProfileSuccess(response) {
    return {
        payload: response.entity,
        type: USER_PROFILE_GET_SUCCESS
    };
}

function getProfileFailure(response) {
    return {
        type: USER_PROFILE_GET_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}


export function updateProfile(userProfile, onSuccess = null) { // is in this file, rather than actions/user.js, since it updates the currently logged in user, and thus uses the auth part of the store.
    return function (dispatch) {
        dispatch(updateProfileRequest());
        client({
            method: 'PUT',
            path: '/api/user/current',
            entity: userProfile,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateProfileSuccess(response));
            if (onSuccess != null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while updating your profile", response));
            dispatch(updateProfileFailure(response));
        });
    };
}

function updateProfileRequest() {
    return {
        type: USER_PROFILE_UPDATE_REQUEST
    };
}

function updateProfileSuccess(response) {
    return {
        payload: response.entity,
        type: USER_PROFILE_UPDATE_SUCCESS
    };
}

function updateProfileFailure(response) {
    return {
        type: USER_PROFILE_UPDATE_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

export function changePassword(changePasswordInfo, onSuccess = null) {  // is in this file, rather than actions/user.js, since it updates the currently logged in user, and thus uses the auth part of the store.
    return function (dispatch) {
        dispatch(changePasswordRequest());
        client({
            method: 'PUT',
            path: '/api/user/current/change-password',
            entity: changePasswordInfo,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(changePasswordSuccess(response));
            if (onSuccess != null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while changing your password", response));
            dispatch(changePasswordFailure(response));
        });
    };
}

export function resetPassword(newPassword, onSuccess = null) {
    return function (dispatch) {
        dispatch(changePasswordRequest());
        client({
            method: 'POST',
            path: '/api/user/reset-password',
            entity: newPassword,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(changePasswordSuccess(response));
            if (onSuccess != null) onSuccess();
            dispatch(push(ROUTE_SIGNIN));
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while resetting your password", response));
            dispatch(changePasswordFailure(response));
        });
    };
}

function changePasswordRequest() {
    return {
        type: USER_CHANGE_PASSWORD_REQUEST
    };
}

function changePasswordSuccess(response) {
    return {
        //payload: response.entity,
        type: USER_CHANGE_PASSWORD_SUCCESS
    };
}

function changePasswordFailure(response) {
    return {
        type: USER_CHANGE_PASSWORD_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}


export function requestPasswordReset(email, onSuccess = null) {
    return function (dispatch) {
        dispatch(requestPasswordResetRequest());
        client({
            method: 'POST',
            path: '/api/user/request-reset-password',
            entity: {
                email: email
            },
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(requestPasswordResetSuccess(response));
            if (onSuccess != null) onSuccess(response.entity.email);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while resetting your password", response));
            dispatch(requestPasswordResetFailure(response));
        });
    };
}

function requestPasswordResetRequest() {
    return {
        type: USER_RESET_PASSWORD_REQUEST
    };
}

function requestPasswordResetSuccess(response) {
    return {
        //payload: response.entity,
        type: USER_RESET_PASSWORD_SUCCESS
    };
}

function requestPasswordResetFailure(response) {
    return {
        type: USER_RESET_PASSWORD_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}


// WEBPACK FOOTER //
// ./src/client/src/actions/auth.js